import { memo } from 'react'
import { Handle, Position, type NodeProps } from '@xyflow/react'
import type { OntologyDomain } from '@/types/ontology'

export interface InstanceNodeData {
  uri: string
  label: string
  typeLabel: string
  domain: OntologyDomain
  selected?: boolean
}

const domainColors: Record<OntologyDomain, { bg: string; border: string; text: string }> = {
  core: {
    bg: '#fdf6e0',
    border: '#d4a020',
    text: '#9a7e1a',
  },
  market: {
    bg: '#e0f5ef',
    border: '#5c8a6b',
    text: '#009b7d',
  },
  business: {
    bg: '#e0eef8',
    border: '#3196e2',
    text: '#076ab8',
  },
  solution: {
    bg: '#fdf6e0',
    border: '#ffc05f',
    text: '#d4a020',
  },
}

export const InstanceNode = memo(({ data, selected }: NodeProps & { data: InstanceNodeData }) => {
  const colors = domainColors[data.domain] || domainColors.solution

  return (
    <>
      <Handle
        type="target"
        position={Position.Left}
        style={{ background: '#8a847a', width: 8, height: 8 }}
      />
      <div
        style={{
          padding: '10px 14px',
          borderRadius: '12px',
          border: `2px solid ${colors.border}`,
          backgroundColor: colors.bg,
          minWidth: '120px',
          maxWidth: '180px',
          boxShadow: selected ? `0 0 0 3px ${colors.border}40` : '0 2px 4px rgba(0,0,0,0.1)',
          transition: 'box-shadow 0.2s',
          cursor: 'pointer',
        }}
      >
        <div
          style={{
            fontSize: '13px',
            fontWeight: 600,
            color: colors.text,
            marginBottom: '4px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {data.label}
        </div>
        <div
          style={{
            fontSize: '10px',
            color: '#8a847a',
            fontFamily: 'monospace',
          }}
        >
          {data.typeLabel}
        </div>
      </div>
      <Handle
        type="source"
        position={Position.Right}
        style={{ background: '#8a847a', width: 8, height: 8 }}
      />
    </>
  )
})

InstanceNode.displayName = 'InstanceNode'
